export function getPublicDiscoverOrigin(): string {
  const raw = import.meta.env.VITE_PUBLIC_PLATFORM_URL?.trim();
  if (raw) {
    return raw.replace(/\/+$/, "");
  }
  return "https://platform.gtsetu.com";
}

export function buildCompanyDiscoverUrl(companyId: string): string {
  return `${getPublicDiscoverOrigin()}/discover/${companyId}`;
}

export async function copyTextToClipboard(text: string): Promise<void> {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.left = "-9999px";
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(textarea);
  if (!ok) {
    throw new Error("Copy failed");
  }
}
